import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { MsalBroadcastService, MsalInterceptor, MsalService } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { Location } from '@angular/common';
import { TokenService } from '../services/token.service';
import { environment } from '../../../../../environments/environment';
import { AuthConfig } from '../configuration/auth.config';

export const BYPASS_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class DfmInterceptor extends MsalInterceptor implements HttpInterceptor {
  constructor(
    authService: MsalService,
    location: Location,
    msalBroadcastService: MsalBroadcastService,
    private tokensService: TokenService
  ) {
    super(
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map(AuthConfig.protectedApis.map((apis) => [apis.url, [apis.scope]])),
        authRequest: {
          redirectUri: `${environment.authentication.redirectUrl}`,
        },
      },
      authService,
      location,
      msalBroadcastService,
      document,
    );
  }

  override intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(BYPASS_INTERCEPTOR)) {
      return next.handle(request);
    }

    return this.tokensService.getTemplatesMgtToken().pipe(
      map((templatesMgtToken) => {
        let modifiedRequest = request;
        //Set both tokens when we send request to the fordesk api
        if (request.url.startsWith(environment.apiHostUrl)) {
          modifiedRequest = request.clone({
            headers: request.headers
              .set('Authorization', `Bearer ${templatesMgtToken}`)
          });
        }
        return modifiedRequest;
      }),
      switchMap((modifiedRequest) => next.handle(modifiedRequest))
    );
  }
}
